import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
    app: {
        font: "'Inter', sans-serif",
        primary: '#455A64',
        primary_dark: '#263238',
        primary_light: '#cfd8dc',
        secondary: '#E8650A',
        secondary_alt: '#0288D1',
        backgroundColor: '#ffffff',
        backgroundColorBase: '#ffffff',
        secondary_dark: '#da2f8a',
        backgroundColor_dark: '#37474f',
        highlighted: '#99CF16',
        backgroundToolbar: '#eceff1',
        textColor: '#263238',
        borderColor: '#DBE2E6',
        disabledOpacity: '0.7',
        isToolbarHidden: false,
        component: {
            tabs: {
                textColor: '#263238',
                fontSize: '14px',
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                padding: '16px 20px',
                borderBottomColor: 'rgba(219, 226, 230, 1)',
                hover: {
                    backgroundColor: '#F6F8F9'
                },
                active: {
                    textColor: 'rgba(222, 89, 0, 1)',
                    borderBottomColor: 'rgba(244, 98, 0, 1)',
                    backgroundColor: '#FEF2ED'
                }
            },
            accordion: {
                titleColor: '#263238',
                lineColor: '#8FA4AE',
                textItemColor: '#263238'
            },
            pageTitle: {
                size: '18px',
                textColor: '#263238',
                weight: '600'
            },
            pageHeader: {
                padding: '16px 0 16px',
                lineHeight: '1.2',
                title: {
                    size: '16px',
                    weight: '500'
                },
                description: {
                    size: '13px'
                }
            },
            dialog: {
                color: '#263238',
                titleSize: '20px'
            },
            card: {
                borderRadius: '8px',
                title: {
                    color: '#263238',
                    weight: '700',
                    size: '16px'
                },
                text: {
                    color: '#263238',
                    weight: '400',
                    size: '14px'
                }
            },
            link: {
                color: '#0288D1',
                decoration: 'none'
            },
            icon: {
                button: {
                    default: {
                        color: '#445A64',
                        width: '26px',
                        height: '26px'
                    },
                    hover: {
                        color: '#263238',
                        width: '26px',
                        height: '26px'
                    }
                },
                info: {
                    default: {
                        color: '#445A64',
                        width: '26px',
                        height: '26px'
                    },
                    hover: {
                        color: '#263238',
                        width: '26px',
                        height: '26px'
                    }
                },
                help: {
                    color: '#E8650A',
                    width: '16px',
                    height: '16px'
                }
            },
            message: {
                backgroundColor: '#FFE1BE',
                padding: '10px 20px',
                borderRadius: '5px',
                fontWeight: '500',
                fontSize: '12px',
                warning: {
                    backgroundColor: '#F8F4c4',
                    color: '#906b27'
                },
                error: {
                    backgroundColor: '#e4644b',
                    color: '#FFFFFF',
                    fontSize: '14px'
                }
            },
            notificationBanner: {
                danger: {
                    backgroundColor: 'rgba(222,89,0,0.1)',
                    iconContainerBGColor: '#DE1C22'
                },
                error: {
                    backgroundColor: '#fff5f5',
                    iconContainerBGColor: '#DE1C22',
                    borderColor: '#de1c22',
                    titleColor: '#de1c22'
                },
                warning: {
                    backgroundColor: 'rgb(255 88 0 / 10%)',
                    iconContainerBGColor: '#E8650A'
                },
                information: {
                    backgroundColor: 'rgb(0 127 255 / 20%)',
                    iconContainerBGColor: '#0069D3'
                },
                success: {
                    backgroundColor: 'rgba(0,133,86,0.1)',
                    iconContainerBGColor: '#008556'
                },
                extra: {
                    backgroundColor: 'rgba(240,4,127,0.1)',
                    iconContainerBGColor: '#F0047F'
                },
                promo: {
                    backgroundColor: 'rgba(153, 207, 22, 0.10)',
                    iconContainerBGColor: '#99CF16'
                },
                deprecated: {
                    backgroundColor: 'rgba(107, 114, 128, 0.1)',
                    iconContainerBGColor: '#6B7280'
                }
            },
            checkbox: {
                borderRadius: '4px',
                width: '20px',
                height: '20px',
                textWeight: '400',
                textSize: '13px',
                unselected: {
                    active: {
                        background: '#FFFFFF',
                        border: '#8FA4AE'
                    },
                    disabled: {
                        background: '#BDC1CC',
                        border: '#D2D5D8'
                    }
                },
                selected: {
                    active: {
                        background: '#E8650A',
                        border: '#E8650A',
                        inputColor: '#E8650A'
                    },
                    disabled: {
                        background: '#BDC1CC',
                        border: '#BDC1CC',
                        inputColor: '#BDC1CC'
                    }
                }
            },
            switch: {
                borderRadius: '12px',
                width: '40px',
                height: '20px',
                default: {
                    backgroundColor: '#DBE2E6',
                    textWeight: '400',
                    textSize: '14px'
                },
                selected: {
                    backgroundColor: '#E8650A',
                    textWeight: '400',
                    textSize: '14px'
                }
            },
            radio: {
                borderRadius: '100%',
                width: '16px',
                height: '16px',
                textWeight: '400',
                textSize: '13px',
                unselected: {
                    active: {
                        background: '#FFFFFF',
                        border: '1px solid #d1d5db'
                    },
                    disabled: {
                        background: '#f4f4f5',
                        border: '1px solid #d1d5db'
                    }
                },
                selected: {
                    active: {
                        background: '#FFFFFF',
                        border: '1px solid #E8650A',
                        inputColor: '#E8650A'
                    },
                    disabled: {
                        background: '#FFFFFF',
                        border: '1px solid #d1d5db',
                        inputColor: '#d1d5db'
                    }
                }
            },
            button: {
                borderRadius: '6px',
                fontSize: '13px',
                fontWeight: '500',
                large: {
                    width: '144px',
                    height: '40px',
                    padding: '8px 20px'
                },
                medium: {
                    width: '100px',
                    height: '32px',
                    padding: '6px 14px'
                },
                small: {
                    width: '80px',
                    height: '32px',
                    padding: '6px 14px'
                },
                primary: {
                    border: '1px solid #E8650A',
                    default: {
                        backgroundColor: '#E8650A',
                        textColor: '#FFFFFF'
                    },
                    hover: {
                        backgroundColor: '#ea6c0b',
                        textColor: '#FFFFFF'
                    },
                    active: {
                        backgroundColor: '#ea6c0b',
                        textColor: '#FFFFFF'
                    },
                    disabled: {
                        opacity: 0.5,
                        backgroundColor: '#E8650A',
                        textColor: '#FFFFFF',
                        border: '1px solid #E8650A'
                    }
                },
                basic: {
                    border: '1px solid #E8650A',
                    default: {
                        backgroundColor: '#FFFFFF',
                        textColor: '#b8532e'
                    },
                    hover: {
                        backgroundColor: '#fff7ed',
                        textColor: '#a04725'
                    },
                    active: {
                        backgroundColor: '#ffedd5',
                        textColor: '#a04725'
                    },
                    disabled: {
                        opacity: 0.5,
                        backgroundColor: '#FFFFFF',
                        textColor: '#b8532e',
                        border: '1px solid #E8650A'
                    }
                },
                destructive: {
                    border: '1px solid #FD5749',
                    default: {
                        backgroundColor: '#DE1C22',
                        textColor: '#FFFFFF'
                    },
                    hover: {
                        backgroundColor: '#BC2200',
                        textColor: '#FFFFFF'
                    },
                    active: {
                        backgroundColor: '#6C0F00',
                        textColor: '#FFFFFF'
                    },
                    disabled: {
                        opacity: 0.5,
                        backgroundColor: '#DE1C22',
                        textColor: '#FFFFFF',
                        border: '1px solid #FD5749'
                    }
                },
                disabled: {
                    border: '1px solid #DDD',
                    backgroundColor: '#DDD',
                    textColor: '#FFFFFF'
                }
            },
            textButton: {
                fontWeight: 600,
                fontSize: '13px',
                iconWidth: '15px',
                iconHeight: '15px',
                primary: {
                    default: {
                        color: '#E8650A'
                    },
                    hover: {
                        color: '#F57A1B'
                    },
                    active: {
                        color: '#C85500'
                    }
                },
                destructive: {
                    default: {
                        color: '#DE1C22'
                    },
                    hover: {
                        color: '#CD290C'
                    },
                    active: {
                        color: '#670F03'
                    }
                }
            },
            pageBlocksContainer: {
                pageBlock: {
                    backgroundColor: '#ffffff',
                    border: '1px solid #eef1f3',
                    borderRadius: '16px',
                    padding: '20px',
                    height: 'auto',
                    pageBlockTitle: {
                        color: '#263238',
                        gap: '10px',
                        fontSize: '14px',
                        fontWeight: 600
                    },
                    pageBlockDescription: {
                        fontSize: '12px'
                    },
                    pageBlockButton: {
                        padding: '6px 12px',
                        fontSize: '13px'
                    },
                    pageBlockLearnMore: {
                        color: '#E8650A',
                        fontSize: '14px',
                        fontWeight: 700
                    }
                }
            },
            propertiesPanel: {
                accordion: {
                    content: {
                        background: '#F6F6F7'
                    }
                }
            }
        }
    },
    input: {
        textSize: '14px',
        color: '#263238'
    },
    text: {
        boldWeight: '600'
    },
    button: {
        color: '#E8650A',
        textColor: '#FFFFFF'
    },
    skeleton: {
        backgroundColor: '#DFDFDF',
        foregroundColor: '#ecebeb'
    },
    size: {
        container: '1232px'
    },
    font: {
        regular: 400,
        medium: 500,
        semi_bold: 600,
        bold: 700,
        extra_bold: 800,
        black: 900
    }
};

export default theme;
